export class RenderEngine {
    constructor(windowWidth, windowHeight, canvasId, background) {
        this.gameObjects = [];
        let canvas = document.getElementById(canvasId);
        if (canvas === null)
            throw new Error('Must add canvas for game to render on');
        canvas.width = windowWidth;
        canvas.height = windowHeight;
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.background = background;
    }
    renderScene(gameObjects) {
        this.gameObjects = [...gameObjects].sort((g1, g2) => g1.transform.depth - g2.transform.depth);
        this.updateCanvas();
    }
    renderTransforms() {
        for (let go of this.gameObjects) {
            this.ctx.fillStyle = go.material.color;
            this.ctx.fillRect(go.transform.position.x, go.transform.position.y, go.transform.size.x, go.transform.size.y);
        }
    }
    renderText() {
        for (let go of this.gameObjects) {
            for (let text of go.text) {
                this.ctx.textAlign = text.align;
                this.ctx.font = text.font;
                this.ctx.fillStyle = text.color;
                this.ctx.fillText(text.text, text.position.x, text.position.y);
            }
        }
    }
    updateCanvas() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = this.background;
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.renderTransforms();
        this.renderText();
    }
}
//# sourceMappingURL=RenderEngine.js.map